import { fetchHandler, HTTP_METHOD, oneLimiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postMessage = (accountId, akteIdHash, payload) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/akten/${akteIdHash}/messages`, HTTP_METHOD.POST, payload)

    return oneLimiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}